
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
// The '!!raw-loader!' syntax is a non-standard, Webpack-specific, syntax.
// See: https://github.com/webpack-contrib/raw-loader#examples
// For now, it seems likely Storybook is pretty tied to Webpack, therefore, we are
// okay with the following Webpack-specific raw loader syntax. It's better to leave
// the ESLint rule enabled globally, and only thoughtfully disable as needed (e.g.
// within a Storybook docs page and not within an actual component).
// This can be revisited in the future if Storybook no longer relies on Webpack.
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import listDemoSource from '!!raw-loader!./demo/list.twig';
import listDemo from './demo/list.twig';
import topics from './demo/topics.json';
import template from './dot-leader.twig';
const argTypes = {
  label: { type: { name: 'string' } },
  count: { type: { name: 'number' } },
  href: { type: { name: 'string' } },
  count_noun_single: { type: { name: 'string' } },
  count_noun_plural: { type: { name: 'string' } },
};
const argDefaults = {
  label: 'Design systems',
  count: 42,
  count_noun_single: 'article',
  count_noun_plural: 'articles',
};


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Components/Dot Leader" mdxType="Meta" />
    <h1>{`Dot Leader`}</h1>
    <p>{`A component that associates a chunk of text with a piece of reference data via a long line of dots, similar to a traditional table of contents or index.`}</p>
    <p>{`A single dot leader is composed of four elements:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`c-dot-leader`}</inlineCode>{` contains the entire row.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`c-dot-leader__start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`c-dot-leader__between`}</inlineCode>{` will output dots and should always include `}<inlineCode parentName="li">{`aria-hidden="true"`}</inlineCode>{` so that it will not be read aloud by assistive devices.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`c-dot-leader__end`}</inlineCode></li>
    </ul>
    <Canvas mdxType="Canvas">
  <Story name="Single" args={argDefaults} argTypes={argTypes} mdxType="Story">
    {args => template(args)}
  </Story>
    </Canvas>
    <p>{`If `}<inlineCode parentName="p">{`c-dot-leader`}</inlineCode>{` is an `}<inlineCode parentName="p">{`<a>`}</inlineCode>{` element, it will gain some additional styles.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Link" args={{
        href: 'https://cloudfour.com/topics/design-systems/',
        ...argDefaults
      }} argTypes={argTypes} mdxType="Story">
    {args => template(args)}
  </Story>
    </Canvas>
    <p>{`Although `}<inlineCode parentName="p">{`c-dot-leader`}</inlineCode>{` applies to a single row, the pattern works best as part of `}<a parentName="p" {...{
        "href": "/docs/objects-list--default-story"
      }}>{`a list object`}</a>{`. The dotted lines clearly associate each column even when content lengths vary.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="List" parameters={{
        docs: {
          source: {
            code: listDemoSource
          }
        }
      }} mdxType="Story">
    {listDemo({
          topics
        })}
  </Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const single = (args => template(args));
single.storyName = 'Single';
single.argTypes = argTypes;
single.args = argDefaults;
single.parameters = { storySource: { source: 'args => template(args)' } };

export const link = (args => template(args));
link.storyName = 'Link';
link.argTypes = argTypes;
link.args = {
  href: 'https://cloudfour.com/topics/design-systems/',
  ...argDefaults
};
link.parameters = { storySource: { source: 'args => template(args)' } };

export const list = () => (
          listDemo({
  topics
})
        );
list.storyName = 'List';
list.parameters = { storySource: { source: 'listDemo({\n  topics\n})' }, ...{
  docs: {
    source: {
      code: listDemoSource
    }
  }
} };

const componentMeta = { title: 'Components/Dot Leader', includeStories: ["single","link","list"],  };

const mdxStoryNameToKey = {"Single":"single","Link":"link","List":"list"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;